import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { CommonFunction } from 'src/app/grievance/common-function';
import { ProjectConstants } from 'src/app/grievance/project-constants';
import { ProgressSpinnerComponent } from 'src/app/progress-spinner/progress-spinner.component';
import { SupportCreateGrievanceListService } from './support-create-grievance-list.service';

const COLS = [
  { value: "NAME", lowercaseValue: "rgName", displayName: "Registered Name" },
  { value: "MOBILE NAME", lowercaseValue: "rgPhoneNo", displayName: "Phone No" },
  { value: "ADDRESS", lowercaseValue: "rgAddress", displayName: "Address" },
  { value: "EMAIL", lowercaseValue: "rgEmailid", displayName: "Email " },
];
export interface userList {
  rgName: any;
  rgPhoneNo: any;
  rgAddress: any;
  rgEmailid: string;
  pkRegid: any;
}
export class UserList {
  rgName: any;
  rgPhoneNo: any;
  rgAddress: any;
  rgEmailid: string;
  pkRegid: any;
}
@Component({
  selector: 'app-support-create-grievance-list',
  templateUrl: './support-create-grievance-list.component.html',
  styleUrls: ['./support-create-grievance-list.component.scss'],
})
export class SupportCreateGrievanceListComponent implements OnInit {
  displayedCols = COLS;
  serachCtrl: FormControl = new FormControl();
  allCols = COLS;
  displayedColumns: any[];
  userLists: any = [];
  searchUser: any;
  filterOptions: any[] = [];
  selectedFilterOption: any = null;
  phoneNumberVisible: boolean = false;
  emailVisible: boolean = false;
  phoneNo: any;
  emaild: any;
  isShowTable: boolean = false;
  progressSpinnerDialog: any = null;
  noUserfound = ProjectConstants.userNotAvailable
  dataSource = new MatTableDataSource(this.userLists);
  @ViewChild(MatPaginator)
  set paginator(value: MatPaginator) {
    this.dataSource.paginator = value;
  }

  constructor(public supportCreateGrievanceService: SupportCreateGrievanceListService,
    public dialog: MatDialog,
    private commonFunction: CommonFunction,
    public router: Router) { }

  async ngOnInit() {
    this.displayedCols = [
      { value: "NAME", lowercaseValue: "rgName", displayName: "Registered Name" },
      { value: "MOBILE NAME", lowercaseValue: "rgPhoneNo", displayName: "Phone No" },
      { value: "ADDRESS", lowercaseValue: "rgAddress", displayName: "Address" },
      { value: "EMAIL", lowercaseValue: "rgEmailid", displayName: "Email " },
    ];
    this.dataSource.paginator = this.paginator;
    this.displayedColumns = this.displayedCols.map((col) => col.value);
  }

  async displayProgressSpinner() {
    this.progressSpinnerDialog = this.dialog.open(ProgressSpinnerComponent, {
      disableClose: true,
      panelClass: "progressSpinner",
    });
  }

  //search user either phone number, email or both
  async SearchGrievance() {
    var data = {
      "searchValue": this.searchUser,
    }
    this.userLists = []
    this.displayProgressSpinner();
    const response: any = await this.supportCreateGrievanceService.searchGrievanceByPhoneorEmail(data);
    this.progressSpinnerDialog.close()
    if (response != null && !response.error) {
      this.isShowTable = true;
      if (response.length != 0) {
        if (response[0].status = ProjectConstants.responseStatusSuccess) {
          let customObj = new UserList();
          for (var i = 0; i < response.length; i++) {
            customObj.pkRegid = response[i].pkRegid;
            // customObj.rgPhoneNo = this.mask_mobile(response[i].rgPhoneNo);
            customObj.rgPhoneNo = response[i].rgPhoneNo;

            customObj.rgName = response[i].rgName;
            customObj.rgAddress = this.text_truncate(response[i].rgAddress, 50, '....');
            customObj.rgEmailid = response[i].rgEmailid;
            // customObj.rgEmailid = this.mask_email(response[i].rgEmailid);

            this.userLists.push(customObj);
          }
          this.dataSource.data = this.userLists;   
        } else {
          await this.commonFunction.errorToast(ProjectConstants.networkErMsg, false, "")
        }
      } else {
        this.userLists = []
        this.dataSource.data = this.userLists;  
      }
    } else {
      await this.commonFunction.errorToast(ProjectConstants.networkErMsg, false, "")
    }
  }
  //

  //address string truncate fun
  text_truncate(str, length, ending) {
    if (str != null) {
      if (str.length > length) {
        return str.substring(0, length - ending.length) + ending;
      } else {
        return str;
      }
    } else {
      return null
    }
  }
  //

  mask_mobile(number) {
    let mask = ''
    if(number!=null){
      for (let i = 1; i <= number.length - 4; i++) {
        mask += '*'
      }
      number = mask + number.slice(6, 10);
  
      return number
    }else{
      return number
    }
   
  }
  // mask_email(mail) {
  //   if(mail!=null){
  //   const [name, domain] = mail.split('@');
  //   const { length: len } = name;
  //   const maskedName = name[0] + '****' + name[len - 1];
  //   const maskedEmail = maskedName + '@' + domain;
  //   return maskedEmail
  //   }else{
  //     return mail
  //   }
  // }

  //when ever user found then add grievance under lottery user then go to reg raise grievance
  gotoLottoryUser(id: any) {
    this.router.navigate(['secure/reg-create-support-user/' + id])
  }
  //
}






